// @module Ames.RentFromAnywhere.RentalGrid
// Registers the "Rental Tools Grid" custom content type (SMT) so it can be
// dropped on any landing page (e.g. /rental) from Site Management Tools.
define("Ames.RentFromAnywhere.RentalGrid", [
  "Ames.RentFromAnywhere.RentalGrid.View"
], function (RentalGridView) {
  "use strict";

  return {
    CCT_ID: "cct_ames_rental_grid",

    mountToApp: function (container) {
      var cms = container.getComponent("CMS");
      if (!cms || !cms.registerCustomContentType) {
        return;
      }

      cms.registerCustomContentType({
        id: this.CCT_ID,
        view: RentalGridView.extend({ application: container })
      });
    }
  };
});
